import * as React from 'react';

var _circle, _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgRefresh = function SvgRefresh(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 44,
        cy: 44,
        r: 30,
        fill: "url(#paint0_linear_19_426)",
        fillOpacity: 0.16
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_426)",
        d: "M28.625 40.131q0 2.757 1.028 4.79a11.2 11.2 0 0 0 2.778 3.523l1.313.918V45.25q0-.57.372-.94.372-.372.94-.373.57 0 .94.372.373.372.373.941v7.438q0 .568-.372.94t-.94.372h-7.438q-.57 0-.94-.372-.373-.372-.373-.94 0-.57.372-.941.373-.372.94-.372h4.376l-.657-.525q-2.799-2.231-4.068-4.856T26 40.13q0-4.111 2.166-7.503a13.9 13.9 0 0 1 5.796-5.14q.482-.219.92 0 .436.218.612.7.219.48 0 .984-.22.503-.7.765a11.55 11.55 0 0 0-4.485 4.222 11.17 11.17 0 0 0-1.684 5.972m22.75-.262q0-2.1-1.028-4.266a13.6 13.6 0 0 0-2.69-3.828l-1.27-1.137v4.112q0 .57-.371.94-.372.372-.941.373-.57 0-.94-.372-.372-.372-.372-.941v-7.437q0-.57.371-.941.372-.372.941-.372h7.438q.568 0 .94.372t.372.94q0 .57-.372.941-.372.372-.94.372h-4.42l.657.613q2.625 2.45 3.938 5.25 1.311 2.8 1.312 5.38 0 4.07-2.1 7.416-2.1 3.348-5.644 5.185-.48.263-.984.065a1.26 1.26 0 0 1-.722-.721 1.16 1.16 0 0 1 0-.985q.22-.502.7-.766a10.83 10.83 0 0 0 4.484-4.2 11.5 11.5 0 0 0 1.641-5.993"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_19_426)",
        d: "M40.011 70q-6.203 0-11.65-2.362-5.445-2.361-9.54-6.451-4.093-4.09-6.457-9.531T10 40.01q0-6.223 2.362-11.7 2.361-5.48 6.451-9.531 4.09-4.053 9.532-6.416Q33.785 10 39.989 10q6.223 0 11.7 2.362 5.48 2.36 9.531 6.41 4.053 4.049 6.416 9.521T70 39.99q0 6.204-2.362 11.65-2.36 5.445-6.41 9.54-4.049 4.093-9.521 6.457T40.01 70M40 67.436q11.449 0 19.442-8.003T67.436 40q0-11.448-7.994-19.442T40 12.564q-11.43 0-19.433 7.994T12.564 40q0 11.43 8.003 19.433T40 67.436"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_426",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_426",
        x1: 26.292,
        x2: 53.61,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_19_426",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgRefresh as ReactComponent };
//# sourceMappingURL=Refresh.svg.es.js.map
